export interface Page {
    description?: string;
    form: any;
    identification: string;
    name: string;
    schema: any;
}
